import React, { useEffect, useState } from 'react'
import { AppBar, Box, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import PageByStatus from './components/PageByStatus'
import DefaultDetailOrder from './pages/detail/Default'
import DeliveryDetailOrder from './pages/detail/Delivery'
import { useStyles } from './NewMyOrder.style'
import { orderStatusCount } from 'api/order'
import DesktopHeaderWrap from 'components/DeskTopHeaderWrap'
import { useAuth } from 'hooks/useAuth'
import { getBadgeCart } from 'api/badge'
import i18n from '../../../language/localization'
import { Container } from '@mui/material'
import Searchbar from 'containers/home/Searchbar'
import { useStore } from 'hooks/useStore'
// import BottNavigation from '../../../../containers/home/bottomnav/NavigationTab'
import RestrictMobile from 'components/RestrictMobile'

const a11yProps = index => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

const TabPanel = props => {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

const NewMyOrder = props => {
  const { token } = useAuth()

  const { themeColor } = useStore()

  const [activeTab, setActiveTab] = useState(0)
  const classes = useStyles(props)
  const [showDetail, setShowDetail] = useState(false)
  const [orderData, setOrderData] = useState({})
  const [categoriesData, setCategoriesData] = useState([])
  const [totalCartItems, setItems] = useState(0)
  const [statusCount, setStatusCount] = useState({
    'WAITING APPROVAL HOD': 0,
    APPROVED: 0,
    ACKNOWLEDGE: 0,
    'ON DELIVERY': 0,
    COMPLETED: 0,
    'REJECTED HOD': 0,
    CANCELED: 0,
    TOTAL: 0,
    PO_STATUS: 0
  })

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const datauser = JSON.parse(localStorage.getItem('userdata'))

  const handleShowDetail = data => {
    setOrderData(data)
    setShowDetail(true)
  }

  const getBadge = async () => {
    if (token) {
      const cartDataResult = await getBadgeCart()
      if (cartDataResult?.success) {
        setItems(cartDataResult.data)
      }
    }
  }

  useEffect(() => {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
    if (localStorage.getItem('landing_page')) {
      setCategoriesData(JSON.parse(localStorage.getItem('landing_page'))['product_categories'])
    }
    getBadge()
    handleGetOrderStatusCount()
  }, [])

  const handleGetOrderStatusCount = async () => {
    try {
      const response = await orderStatusCount()
      setStatusCount(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  if (!datauser) {
    return <></>
  }

  if (isMobile && datauser.role === 'requestor') {
    return <RestrictMobile />
  }

  return (
    <div>
      {isMobile ? (
        <React.Fragment>
          {isMobile ? <Searchbar color={themeColor} title='Order' /> : null}
        </React.Fragment>
      ) : (
        <DesktopHeaderWrap
          themeColor={'rgb(231, 0, 116)'}
          categoriesData={categoriesData}
          cartNumber={totalCartItems}
        />
      )}
      {showDetail ? (
        <Container className={classes.body}>
          <div style={{ paddingTop: 12 }}>
            {[3, 4].includes(activeTab) ? (
              <DeliveryDetailOrder
                data={orderData}
                onBack={() => {
                  setShowDetail(false)
                  setOrderData({})
                }}
              />
            ) : (
              <DefaultDetailOrder
                data={orderData}
                onBack={() => {
                  setShowDetail(false)
                  setOrderData({})
                }}
              />
            )}
          </div>
        </Container>
      ) : (
        <div style={{ paddingTop: isMobile ? '48px' : '60px' }}>
          <div className={classes.tablist}>
            <AppBar position='static' style={{ boxShadow: 'none' }}>
              <div style={{ maxWidth: isMobile ? '100%' : 1320, margin: '0 auto' }}>
                <Tabs
                  value={activeTab}
                  onChange={(_, value) => setActiveTab(value)}
                  aria-label='simple tabs example'
                >
                  <Tab
                    label={`Waiting Approval (${statusCount['WAITING APPROVAL HOD']})`}
                    {...a11yProps(0)}
                  />
                  <Tab label={`Approved (${statusCount.APPROVED})`} {...a11yProps(1)} />
                  <Tab label={`Acknowledgement (${statusCount.ACKNOWLEDGE})`} {...a11yProps(2)} />
                  <Tab label={`On Delivery (${statusCount['ON DELIVERY']})`} {...a11yProps(3)} />
                  <Tab label={`Completed (${statusCount.COMPLETED})`} {...a11yProps(4)} />
                  <Tab label={`Rejected (${statusCount['REJECTED HOD']})`} {...a11yProps(5)} />
                  <Tab label={`Canceled (${statusCount.CANCELED})`} {...a11yProps(6)} />
                  <Tab label={`Open PO (${statusCount.PO_STATUS})`} {...a11yProps(7)} />
                </Tabs>
              </div>
            </AppBar>
          </div>
          <Container>
            <div className={classes.content}>
              <TabPanel value={activeTab} index={0}>
                <PageByStatus status='WAITING APPROVAL HOD' showDetail={handleShowDetail} />
              </TabPanel>
              <TabPanel value={activeTab} index={1}>
                <PageByStatus status='APPROVED' showDetail={handleShowDetail} />
              </TabPanel>
              <TabPanel value={activeTab} index={2}>
                <PageByStatus status='ACKNOWLEDGE' showDetail={handleShowDetail} />
              </TabPanel>
              <TabPanel value={activeTab} index={3}>
                <PageByStatus status='ON DELIVERY' showDetail={handleShowDetail} />
              </TabPanel>
              <TabPanel value={activeTab} index={4}>
                <PageByStatus status='COMPLETED' showDetail={handleShowDetail} />
              </TabPanel>
              <TabPanel value={activeTab} index={5}>
                <PageByStatus status='REJECTED HOD' showDetail={handleShowDetail} />
              </TabPanel>
              <TabPanel value={activeTab} index={6}>
                <PageByStatus status='CANCELED' showDetail={handleShowDetail} />
              </TabPanel>
              <TabPanel value={activeTab} index={7}>
                <PageByStatus
                  status='APPROVED,ACKNOWLEDGE,ON DELIVERY'
                  showDetail={handleShowDetail}
                />
              </TabPanel>
            </div>
          </Container>
        </div>
      )}
      {/* {isMobile && <BottNavigation />} */}
    </div>
  )
}

export default NewMyOrder
